import React, { useEffect, useState } from "react";
import cn from "classnames";
import styles from "./Shop.module.sass";
import Card from "../../components/Card";
import { UseDisclosure } from "../../hooks/use-disclosure";
import { UseApi } from "../../hooks/use-api";
import { GetCategoriesSimple } from "../../Services/lib/admin";
import { GetCollectionsSimple } from "../../Services/lib/nft";
import Dropdown from "../../components/Dropdown";
import Form from "../../components/Form";
import { GetNFTs } from "../../Services/lib/nft";
import { Pager } from "../../components/Pager";
import Empthy from "../../components/Empty";
import Loader from "../../components/Loader";
import Icon from "../../components/Icon";
import NFTModal from "../../components/NFTModal";
import { useUser } from "../../context";
import communityMarketplace from "../../i11/CommunityMarketplace";
const limit = 12;

const Shop = () => {
	const { locale } = useUser();
	const { isOpen, onClose, onOpen } = UseDisclosure();
	const [product, setProduct] = useState();
	const [{ data: categories }, getCategory] = UseApi({
		service: GetCategoriesSimple,
	});
	const [{ data: collections }, getCollection] = UseApi({
		service: GetCollectionsSimple,
	});

	const [{ isLoading }, fetch] = UseApi({
		service: GetNFTs,
	});

	const [category, setCategory] = useState(
		communityMarketplace[locale].category
	);
	const [offset, setOffset] = useState(1);
	const [collection, setCollection] = useState(
		communityMarketplace[locale].collection
	);
	const [val, setVal] = useState("");
	const [search, setSearch] = useState("");
	const [page, setPage_] = useState(1);
	const [total, setTotal] = useState(1);
	const [nfts, setNfts] = useState([]);

	const setPage = (e) => {
		setPage_(e);
		const lOffset = (e - 1) * limit;
		if (offset !== lOffset) {
			setOffset(lOffset);
		}
	};

	const close = () => {
		setProduct();
		onClose();
	};

	const open = (data_) => {
		setProduct(data_);
		onOpen();
	};

	const init = () => {
		getCollection();
		getCategory();
	};

	useEffect(() => {
		init();
	}, []);

	const getNFts_ = async () => {
		let nftCollectionId = "";
		collections?.forEach((element) => {
			if (element.name === collection) {
				nftCollectionId = element._id;
			}
		});
		let categoryId = "";
		categories?.forEach((element) => {
			if (element.title === category) {
				categoryId = element._id;
			}
		});
		const res = await fetch({
			limit,
			offset,
			nftCollectionId,
			categoryId,
			search,
		});
		if (res) {
			setNfts(res.nfts);
			setTotal(Math.ceil(res.count / limit));
		}
	};

	useEffect(() => {
		getNFts_();
	}, [search, category, collection, offset]);

	const handleSubmit = (e) => {
		e.preventDefault();
		setSearch(val);
	};

	return (
		<>
			<div className={styles.shop}>
				<div className={styles.background}>
					<img src="/images/content/bg-shop.jpg" alt="Background" />
				</div>
				<Card
					title={communityMarketplace[locale].marketplace}
					classTitle={cn("title-blue", styles.cardTitle)}
					className={styles.card_}
					head={
						<>
							<Form
								className={styles.form}
								value={val}
								setValue={setVal}
								onSubmit={handleSubmit}
								required={false}
								placeholder={communityMarketplace[locale].search}
								type="text"
								name="search"
								icon="search"
							/>
							<Dropdown
								className={styles.dropdown}
								classDropdownHead={styles.dropdownHead}
								value={collection}
								setValue={setCollection}
								options={collections?.map((e) => e.name) || []}
								small
							/>
							<Dropdown
								className={cn(styles.margin, styles.dropdown)}
								classDropdownHead={styles.dropdownHead}
								value={category}
								setValue={setCategory}
								options={categories?.map((e) => e.title) || []}
								small
							/>
						</>
					}
				>
					<div className={styles.filterArr}>
						{collection !== communityMarketplace[locale].collection && (
							<div
								onClick={() => {
									setCollection(communityMarketplace[locale].collection);
								}}
							>
								{collection} <Icon name="trash" size="18" />
							</div>
						)}
						{category !== communityMarketplace[locale].category && (
							<div
								onClick={() => {
									setCategory(communityMarketplace[locale].category);
								}}
							>
								{category}
								<Icon name="trash" size="18" />{" "}
							</div>
						)}
					</div>
					{isLoading ? (
						<div className={styles.loaderWrap}>
							<Loader className={styles.loader} />
						</div>
					) : nfts.length > 0 ? (
						<div className={styles.container}>
							{nfts.map((e) => {
								return <ProductCard key={e._id} data={e} open={open} />;
							})}
						</div>
					) : (
						<Empthy />
					)}
					<div className={styles.foot}>
						<Pager page={page} setPage={setPage} total={total} />
					</div>
				</Card>
			</div>
			<NFTModal visible={isOpen && product} onClose={close} data={product} />
		</>
	);
};

const ProductCard = ({ data, open }) => {
	return (
		<div
			onClick={() => {
				open(data);
			}}
			className={styles.card}
		>
			<div className={styles.img}>
				<img src={data.image} alt={data.name} />
			</div>
			<div className={styles.nftTitle}>{data.name}</div>
			<div className={styles.price}>
				<div>Price</div>
				<div>
					$ {data.price} {data.currency}
				</div>
			</div>
		</div>
	);
};

export default Shop;
